import {
  SICK_DEATH_MS,
  SICK_HEALTH_DURATION_MS,
  SICK_HEALTH_THRESHOLD,
  SICK_POOP_THRESHOLD,
} from './constants';

export interface DiseaseState {
  sick: boolean;
  sickSince: number | null;
  healDoses: number;
  lastHealAt: number | null;
  lowHealthSince: number | null;
}

export interface DiseaseTickResult extends DiseaseState {
  /** True se a doença levou à morte neste tick. */
  dead: boolean;
}

export function tickDisease(
  state: DiseaseState,
  health: number,
  poopCount: number,
  nowMs: number,
  sleeping: boolean,
  timings: { sickHealthDurationMs?: number; sickDeathMs?: number } = {},
): DiseaseTickResult {
  const sickHealthDurationMs = timings.sickHealthDurationMs ?? SICK_HEALTH_DURATION_MS;
  const sickDeathMs = timings.sickDeathMs ?? SICK_DEATH_MS;
  let { sick, sickSince, healDoses, lastHealAt, lowHealthSince } = state;

  if (health < SICK_HEALTH_THRESHOLD) {
    if (lowHealthSince === null) lowHealthSince = nowMs;
  } else {
    lowHealthSince = null;
  }

  if (!sick && lowHealthSince !== null && nowMs - lowHealthSince >= sickHealthDurationMs) {
    sick = true;
    sickSince = nowMs;
  }
  if (!sick && poopCount > SICK_POOP_THRESHOLD) {
    sick = true;
    sickSince = nowMs;
  }

  let dead = false;
  if (sick && sickSince !== null && !sleeping && nowMs - sickSince >= sickDeathMs) {
    dead = true;
  }

  return { sick, sickSince, healDoses, lastHealAt, lowHealthSince, dead };
}

export interface HealResult {
  state: DiseaseState;
  accepted: boolean;
}

export function applyHeal(state: DiseaseState, nowMs: number): HealResult {
  if (!state.sick) return { state, accepted: false };
  const next: DiseaseState = {
    sick: false,
    sickSince: null,
    healDoses: 0,
    lastHealAt: nowMs,
    lowHealthSince: state.lowHealthSince,
  };
  return { state: next, accepted: true };
}

export function applyHealWithCooldown(state: DiseaseState, nowMs: number, cooldownMs = 0): HealResult {
  void cooldownMs;
  return applyHeal(state, nowMs);
}
